/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTags} from '../api'

 export const useQueryGetTags = createReactQueryHook('getTags', getTags)
